import type { UseHitsProps } from "react-instantsearch";
import { useHits, useInstantSearch } from "react-instantsearch";
import Hit from "#/app/components/search/components/Hit.tsx";
import { m } from "#/paraglide/messages";
import type { SearchIndexHit } from "../types";

export default function SearchHits(props: UseHitsProps<SearchIndexHit>) {
	const { items, sendEvent } = useHits<SearchIndexHit>(props);
	const { results } = useInstantSearch();

	if (results.nbHits === 0) {
		return <p className="pt-4 text-muted">{m.search_no_results()}</p>;
	}

	return (
		<section className="search-results" aria-live="polite">
			<div className="search-results-count">
				<span>{results.nbHits}</span>
				<span>
					{results.nbHits === 1 ? m.search_result() : m.search_results()}
				</span>
			</div>
			<div className="flex flex-col">
				{items.map((item) => (
					<Hit key={item.objectID} hit={item} sendEvent={sendEvent} />
				))}
			</div>
		</section>
	);
}
